define( [
	"./class2type"
], function( class2type ) {
	"use strict";

	return class2type.hasOwnProperty;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/var/hasOwn.js
// module id = 29
// module chunks = 0